import { ChevronDown } from "lucide-react";
import { useState } from "react";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";

interface ExamSwitcherPopoverProps {
  stateName: string;
  subtitle: string;
}

export function ExamSwitcherPopover({
  stateName,
  subtitle,
}: ExamSwitcherPopoverProps) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  const handleChangeExamType = () => {
    setOpen(false);
    navigate("/exam-selection");
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button className="group block w-full min-w-0 text-left" type="button">
          <span className="flex min-w-0 items-center gap-1.5 text-base font-semibold leading-6 text-[#0a0c11] sm:text-lg sm:leading-[27px]">
            <span className="truncate">{stateName}</span>
            <ChevronDown
              aria-hidden="true"
              className="h-5 w-5 transition-transform group-data-[state=open]:rotate-180"
            />
          </span>
          <span className="hidden max-w-full truncate text-sm leading-[21px] tracking-[0.07px] text-[#5b616d] sm:block">
            {subtitle}
          </span>
        </button>
      </PopoverTrigger>
      <PopoverContent
        align="start"
        className="w-[min(274px,calc(100vw-32px))] rounded-2xl border-0 bg-white p-4 shadow-[0_4px_6px_rgba(0,0,0,0.05),0_10px_15px_rgba(0,0,0,0.10)]"
        onOpenAutoFocus={(event) => event.preventDefault()}
        sideOffset={4}
      >
        <div>
          <p className="text-lg font-semibold leading-[27px] text-[#0a0c11]">
            {stateName}
          </p>
          <p className="truncate text-sm leading-[21px] tracking-[0.07px] text-[#5b616d]">
            {subtitle}
          </p>
        </div>
        <button
          className="mt-4 flex h-[51px] w-full items-center justify-center rounded-full border-[1.5px] border-[var(--dp-brand-button)] bg-white px-6 text-base font-medium leading-6 text-[var(--dp-brand-button)] outline-none focus-visible:ring-2 focus-visible:ring-[var(--dp-brand-button)] focus-visible:ring-offset-2"
          onClick={handleChangeExamType}
          type="button"
        >
          {t("examType.change_exam_type")}
        </button>
      </PopoverContent>
    </Popover>
  );
}
